"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumMapper = void 0;
class EnumMapper {
    constructor(map) {
        this.map = map;
    }
    toVod(v3) {
        return this.map[v3];
    }
    toGql(v2) {
        for (const v3 in this.map) {
            if (this.map[v3] === v2) {
                return v3;
            }
        }
    }
}
exports.EnumMapper = EnumMapper;
//# sourceMappingURL=enum-mapper.js.map